import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { CompanyTypeEditService } from '../../service/company-type-edit/company-type-edit.service';

@Component({
	selector: 'app-company-type-edit',
	templateUrl: './company-type-edit.component.html',
	providers: [
		CompanyTypeEditService,
		HttpModule
	]
})
export class CompanyTypeEditComponent implements OnInit {

	private token;
	private sub: any;
	companyType: FormGroup;
	ID: string;
	Tipo: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;
	public permissoes: any[] = [];

	constructor(fb: FormBuilder, private companyTypeEditService: CompanyTypeEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.companyType = fb.group({
			'ID': '',
			'Tipo': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.companyTypeEditService.loadCompanyType(this.token, this.ID).subscribe(result => {
				var updateCompanyTtype = result.Result;
				this.companyType.setValue({
					ID: updateCompanyTtype.ID,
					Tipo: updateCompanyTtype.Tipo,
					Ativo: updateCompanyTtype.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editCompanyType(value: any) {
		console.log(value);
		this.companyTypeEditService.editCompanyType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-empresa');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-empresa');
	}

}


// WEBPACK FOOTER //
// ./src/app/company-type/component/company-type-edit/company-type-edit.component.ts